import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import { usePagination } from '../../../../shared/hooks/use-pagination';
import { convertServerDateTimeString } from '../../../../shared/utils/format-date/format-date';
import { UserSettings } from '../../../user/models/user-settings';
import { useGetCustomersQuery } from '../../api/customers-api';
import CustomerDeleteModal from '../customer-delete-modal/customer-delete-modal';
import CustomerFormModal from '../customer-form-modal/customer-form-modal';
import CustomerFormSendDocumentModal from '../customer-form-send-document-modal/customer-form-send-document-modal';
import CustomerFormSendFile from '../customer-form-send-file/customer-form-send-file';
import CustomersHeader from '../customers-header/customers-header';
import CustomersList from '../customers-list/customers-list';
import CustomersTable from '../customers-table/customers-table';
import styles from './customers-content.module.css';
import { useGetUserSettingsQuery } from '../../../user/api/user-api';

const CustomersContent = (): JSX.Element => {
  const screens = useBreakpoint();
  const [searchParams] = useSearchParams();
  const [pageSize, setPageSize] = useState<number>();
  const { data: userSettings } = useGetUserSettingsQuery();

  const { data: customersData, isFetching: isCustomerDataFetching } = useGetCustomersQuery(
    {
      page: Number(searchParams.get('page')) || 1,
      name: searchParams.get('name') || '',
      phone: searchParams.get('phone') || '',
      email: searchParams.get('email') || '',
      surname: searchParams.get('surname') || '',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      limit: pageSize!,
    },
    {
      skip: !pageSize,
    },
  );

  const [limit, pagination] = usePagination(customersData?.total, UserSettings.CustomersPageSize);

  const customersDataSource = useMemo(() => {
    return (customersData && Array.isArray(customersData.items) ? customersData.items : []).map(
      ({ id, name, surname, email, phone, createdAt, updatedAt }) => ({
        id,
        name,
        surname,
        email,
        phone,
        createdAt: convertServerDateTimeString(createdAt, userSettings?.[UserSettings.DateFormat]),
        updatedAt: convertServerDateTimeString(updatedAt, userSettings?.[UserSettings.DateFormat]),
      }),
    );
  }, [customersData, userSettings]);

  useEffect(() => {
    setPageSize(limit);
  }, [limit]);

  return (
    <>
      <CustomersHeader pagination={pagination} />
      {screens.sm ? (
        <div className={styles.contentContainer}>
          <CustomersTable customersDataSource={customersDataSource} isCustomerDataFetching={isCustomerDataFetching} />
        </div>
      ) : (
        <CustomersList customersDataSource={customersDataSource} isCustomerDataFetching={isCustomerDataFetching} />
      )}
      <CustomerDeleteModal />
      <CustomerFormModal />
      <CustomerFormSendFile />
      <CustomerFormSendDocumentModal />
    </>
  );
};
export default CustomersContent;
